export enum WSS_EVENTS {
  WSS_CHAT_TOKEN_REQUEST = 'WSS/CHAT-TOKEN/REQUEST',
  WSS_CHAT_TOKEN_RECEIVED = 'WSS/CHAT-TOKEN/RECEIVED',
  WSS_REQUEST_ERROR = 'WSS/ERRORED',
}
